import React from "react";

interface DashedConnectorProps {
  width?: number;
  height?: number;
  /**
   * Which of the design's two squiggles to use. Omit for the two-key layout,
   * whose gap is too different a shape to stretch either one into; that falls
   * back to a curve generated to fit.
   */
  variant?: 1 | 2;
}

// The design authors these vertically; the matrix turns them a quarter turn so
// the `d` can stay verbatim.
const VARIANTS = {
  1: {
    viewBox: "0 0 178 21",
    transform: "matrix(0 -1 1 0 0 21)",
    d: "M2.00005 176C31.5001 140.5 2.00014 80.5931 2.00005 55.5352C1.99989 9.89744 14.7169 2.00007 19.0001 2",
  },
  2: {
    viewBox: "0 0 162.001 23.5273",
    transform: "matrix(0 -1 1 0 0 23.5273)",
    d: "M9.12216 160C-5.47267 122.5 21.5274 82.0578 21.5273 57C21.5272 11.3622 -1.75719 2.00007 2.52593 2",
  },
} as const;

export const DashedConnector = ({
  width = 200,
  height = 60,
  variant,
}: DashedConnectorProps) => {
  const shape = variant
    ? VARIANTS[variant]
    : {
        viewBox: `0 0 ${width} ${height}`,
        transform: undefined,
        d: `M0 ${height * 0.7}C${width * 0.25} ${height * 0.1} ${width * 0.75} ${height * 0.9} ${width} ${height * 0.3}`,
      };
  return (
    <svg
      width={width}
      height={height}
      viewBox={shape.viewBox}
      preserveAspectRatio="none"
      fill="none"
      aria-hidden
    >
      <path
        d={shape.d}
        transform={shape.transform}
        stroke="#1c252e"
        strokeWidth="4"
        strokeDasharray="8 8"
        strokeLinecap="round"
        strokeLinejoin="round"
        vectorEffect="non-scaling-stroke"
        fill="none"
      />
    </svg>
  );
};
